// NOTE: This component is being reused for multiple forms. To ensure no conflicts occur in the
// Redux state, do not render more than one of these components in the DOM at the same time
import { TextField, kycStatuses } from 'entoro-shared';
import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';
import React from 'react';
import { connect } from 'react-redux';
import { CONTACT_EMAIL_DEFAULT } from '../../config';

import { Field, reduxForm } from 'redux-form';

const OfferActionForm = reduxForm({
  form: 'offerActionForm',
})(
  ({
    disabled,
    hideCancelButton,
    handleSubmit,
    submitting,
    request,
    title,
    dialogBody,
    handleClose,
    enableMessage,
    submitText,
    acuantKyc,
    kycStatus,
  }) => (
    <form onSubmit={handleSubmit(request)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {acuantKyc && (
            <React.Fragment>
              <b>{`Current Status: Pending`}</b>
              <br />
              <br />
              {
                'In order to continue the investment process, we require a background check as part of the screening process.'
              }
              <br />
              <br />
              <i>
                If you have any questions about verification or need assistance
                getting verified, please contact{' '}
                <a href={`mailto:${CONTACT_EMAIL_DEFAULT}`}>
                  {CONTACT_EMAIL_DEFAULT}
                </a>
                .
              </i>
            </React.Fragment>
          )}

          <br />

          {dialogBody}
        </DialogContentText>

        <br />
      </DialogContent>
      {enableMessage && (
        <Field component={TextField} name='message' label='Message' multiline />
      )}
      {!acuantKyc && (
        <DialogActions>
          {!hideCancelButton ? (
            <Button
              disabled={submitting}
              onClick={handleClose}
              className='action-button cancel'
              disableRipple
            >
              Cancel
            </Button>
          ) : null}
          <Button
            type='submit'
            disabled={disabled || submitting}
            className='action-button'
            disableRipple
          >
            {submitting ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress size={15} color='inherit' />
                &nbsp;
                {submitText}
              </div>
            ) : (
              submitText
            )}
          </Button>
        </DialogActions>
      )}
    </form>
  )
);

const mapStateToProps = ({ investorUser = {} }, { offerId }) => {
  const { kycStatus } = investorUser;

  return {
    kycStatus,
  };
};
export default connect(mapStateToProps)(OfferActionForm);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferActionForm.js